export default "__VITE_ASSET__eqaoPPWw__"